import React from "react";
import { observer, inject } from "mobx-react";
import { Statistic } from "antd";

const { Countdown } = Statistic;

interface CountdownWrapperProps {
  store?: any;
  style?: any;
  expires: any;
  onExpiry: any;
  format?: string;
}

@inject("store")
@observer
export class CountdownWrapper extends React.Component<CountdownWrapperProps> {
  public render() {
    return this.props.expires ? (
      <Countdown
        value={this.props.expires}
        format={this.props.format ? this.props.format : "HH:mm"}
        valueStyle={this.props.style}
        onFinish={this.props.onExpiry}
      />
    ) : null;
  }
}
